import { genders } from '../../constants';

export const MapGenderValueToName = genderValue => {
  const allGenders = genders();

  const gender = allGenders.filter(g => g.value === genderValue)[0];

  return gender.name;
};
